import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FirearmOwnerForm from '../../../components/forms/FirearmOwnerForm';
import { useCreateFirearmOwner } from '../../../hooks/useFirearmOwnerApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { FirearmOwnerDTO } from '../../../services/apiClient';

const FirearmOwnerCreate: React.FC = () => {
  const createFirearmOwner = useCreateFirearmOwner();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Firearm Owners', href: '/admin/firearmowners' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: FirearmOwnerDTO) => {
    try {
      await createFirearmOwner.mutateAsync(data);
      navigate('/admin/firearmowners');
    } catch (error) {
      console.error('Error creating Firearm Owner:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/firearmowners"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.FirearmOwner.Edit'
    >
        <FirearmOwnerForm
          initialValues={{} as FirearmOwnerDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/firearmowners')}
        />
    </AdminLayout>
  );
};

export default FirearmOwnerCreate;